import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "bottom_left", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 6 6", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("path", { d: "M2.5 3.5h2a1 1 0 010 2h-3a1 1 0 01-1-1v-3a1 1 0 012 0v2z", fill: "#FFF", stroke: "red" }));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
